import GLPass from "./GLPass";
import { Canvasbuffer } from "./utils/CanvasBuffer";
import quadGeometry from "./utils/quadGeometry";

export default class GLRenderer{
    constructor({engine, inCanvas, passes}) {
        this.outCanvas = document.createElement("canvas");
        this.gl = this.outCanvas.getContext('webgl');
        this.inCanvas = inCanvas;
        this.engine = engine;
        this.geometry = quadGeometry(this.gl);
        this.canvasbuffer = new Canvasbuffer({gl: this.gl, canvas: this.inCanvas});


        this.passes = [];
        for(let i = 0; i < passes.length; i++){
            const pass = new GLPass({gl:this.gl, geometry: this.geometry, fragment: passes[i].fragment, uniforms: passes[i].uniforms});
            pass.material.uniforms.sampler.value = i==0 ? this.canvasbuffer.texture : this.passes[i-1].texture;
            //pass.material.uniforms.sampler.value = this.canvasbuffer.texture;
            this.passes.push(pass);
        }
    }

    resize(w, h){
        this.gl.canvas.width = w;
        this.gl.canvas.height = h;
        for(let i = 0; i < this.passes.length; i++){
            this.passes[i].resize(w,h);
        }
        this.gl.viewport(0, 0, this.gl.canvas.width, this.gl.canvas.height);
    }

    render(){   
        this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);

        this.canvasbuffer.update();

        for(let i = 0; i < this.passes.length; i++){
            this.passes[i].material.uniforms.resolution.value = [this.gl.canvas.width, this.gl.canvas.height];
            this.passes[i].material.uniforms.time.value = this.engine.time.time;
            this.passes[i].render(i==this.passes.length-1);
        }
    }
}

  